import { memo } from 'react';

type CitationTableProps = {
  data: string;
};

export const CitationTable = memo(({ data }: CitationTableProps) => {
  try {
    const parsedData = JSON.parse(data);
    if (!Array.isArray(parsedData) || parsedData.length === 0) {
      return (
        <pre
          className="p-3 rounded-lg overflow-auto"
          style={{
            backgroundColor: 'var(--bq-surface-muted)',
            color: 'var(--bq-text-primary)',
            border: '1px solid var(--bq-border-muted)',
          }}
        >
          {data}
        </pre>
      );
    }

    const headers = Object.keys(parsedData[0]);

    return (
      <div>
        <table className="citation-data-table">
          <thead>
            <tr>
              {headers.map((header) => (
                <th key={header}>
                  {header
                    .split(/(?=[A-Z])|_/)
                    .map(
                      (word) =>
                        word.charAt(0).toUpperCase() +
                        word.slice(1).toLowerCase(),
                    )
                    .join(' ')}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {parsedData.map(
              (row: Record<string, string | number>, index: number) => (
                <tr key={index}>
                  {headers.map((header) => (
                    <td key={`${index}-${header}`}>
                      {typeof row[header] === 'number'
                        ? Number(row[header]).toLocaleString(undefined, {
                            maximumFractionDigits: 2,
                          })
                        : row[header]}
                    </td>
                  ))}
                </tr>
              ),
            )}
          </tbody>
        </table>
      </div>
    );
  } catch (error) {
    console.error('Error parsing citation data:', error);
    return (
      <pre
        className="p-3 rounded-lg overflow-auto"
        style={{
          backgroundColor: 'var(--bq-surface-muted)',
          color: 'var(--bq-text-primary)',
          border: '1px solid var(--bq-border-muted)',
        }}
      >
        {data}
      </pre>
    );
  }
});
